var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:this.deviceClass == 'pc' ? 'shortBox' : 'shortBoxH'},[_c(_vm.currentComponent,{key:_vm.type,tag:"component",attrs:{"detail":_vm.detail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }